import React from "react";
import Text from "../../Components/Text";
import { Button } from "../../Components";
import { useRouter } from "next/router";

type CardLoanProps = React.ComponentPropsWithoutRef<"div"> & {
  title: string;
  description: string;
  imageSrc: string;
  path: string;
};

const CardLoan: React.FC<CardLoanProps> = (props) => {
  const { title, description, imageSrc, path, ...restProps } = props;
  const { push } = useRouter();

  return (
    <React.Fragment>
      <div className="card-loan__wrapper" {...restProps}>
        <img className="card-loan__image" src={imageSrc} alt={title} />
        <div className="card-loan__body">
          <div className="card-loan__text" id="title">
            <Text
              fontFamily={["Roboto", "Roboto"]}
              fontSize={["17px", "34px"]}
              fontWeight={["700", "700"]}
              lineHeight={["24px", "24px"]}
              textAlign={["left", "left"]}
              color={["#FFFFFF", "#FFFFFF"]}
            >
              {title}
            </Text>
          </div>
          <div className="card-loan__text" id="subtitle">
            <Text
              fontFamily={["Roboto", "Roboto"]}
              fontSize={["14px", "16px"]}
              lineHeight={["24px", "24px"]}
              textAlign={["left", "left"]}
              color={["#FFFFFF", "#FFFFFF"]}
            >
              {description}
            </Text>
          </div>
          <Button onClick={() => push(path)}>Selengkapnya</Button>
        </div>
      </div>
      <style jsx scoped>{`
        .card-loan__wrapper {
          position: relative;
          display: flex;
          flex-direction: column;
          border-radius: 8px;
          max-width: 524px;
          width: 100%;
          margin: 16px;
        }

        .card-loan__image {
          width: 100%;
          height: auto;
          border-radius: 8px;
        }

        .card-loan__body {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          margin: 32px 24px;
          z-index: 1;
        }

        .card-loan__text {
          margin-bottom: 10px;
        }

        @media only screen and (max-width: 500px) {
          .card-loan__wrapper {
            width: auto;
          }

          .card-loan__body {
            margin: 16px;
          }

          .card-loan__text {
            margin-bottom: 8px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default CardLoan;
